import { mainStore } from '../stores/MainStore';

export const useClaimsStore = () => {
  return mainStore.claimsStore;
};

